import BannerExperienciaService from '../services/banner.experiencia.service';

export const bannerExperiencia = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return BannerExperienciaService.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
